var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPptBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 2460 c-250 -49 -575 -112 -722 -141 l-268 -52 0 -993 c0 -547 3 -994 7 -994 4 0 323 -61 709 -135 386 -74 711 -135 723 -135 l21 0 0 1270 c0 699 -3 1270 -7 1269 -5 0 -213 -40 -463 -89z m-82 -715 c68 -23 144 -91 167 -147 9 -23 19 -72 22 -109 11 -127 -34 -227 -130 -293 -75 -51 -127 -66 -254 -73 l-113 -6 0 -169 0 -168 -115 0 -115 0 0 403 c0 222 3 446 7 496 l6 93 236 -4 c197 -4 245 -8 289 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610 1446 l0 -156 63 0 c87 0 130 15 166 56 27 31 31 42 31 95 0 110 -46 149 -182 157 l-78 5 0 -157z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1578 2254 c-10 -9 -10 -253 -2 -346 7 -64 8 -67 27 -56 28 14 116 38 145 38 l22 0 0 -210 0 -210 210 0 c235 0 218 7 199 -82 -31 -144 -137 -263 -283 -314 -62 -23 -200 -20 -263 5 l-51 20 -6 -37 c-3 -20 -6 -90 -6 -154 l0 -118 245 0 245 0 0 -100 0 -100 -242 -2 -243 -3 0 -145 0 -145 462 0 462 1 26 24 25 23 0 932 0 932 -26 24 -26 24 -456 3 c-251 2 -460 1 -464 -4z m427 -291 c64 -22 117 -58 167 -111 65 -70 98 -140 112 -239 l6 -43 -210 0 -210 0 0 211 0 210 48 -7 c26 -4 65 -13 87 -21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptBw);
export default __webpack_public_path__ + "static/media/ppt_bw.39fdbc0aea0148d7c4f350398f128ec7.svg";
export { ForwardRef as ReactComponent };